document.addEventListener('DOMContentLoaded', function () {
  // ===== PASSWORD CONFIG =====
  var INTERNAL_PASSWORD = 'Brand153';

  var lock        = document.getElementById('bb-batch-lock');
  var wrapper     = document.getElementById('bb-batch-wrapper');
  var passInput   = document.getElementById('bb-batch-pass');
  var unlockBtn   = document.getElementById('bb-batch-unlock');
  var errorEl     = document.getElementById('bb-batch-error');
  var initialized = false;

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  // Tracks whether this load uses OGIVE or COAL in the QC label
  var currentMeasureMode = 'COAL'; // 'COAL' or 'OGIVE'

  // ==== REAL LOAD RECIPES, DOPE & VELOCITY CALIBRATION ====
  // All .375 brass assumed Peterson 2.994" OAL per your note.
  var RECIPES = {
    // .375 Cheytac - 390GR Hornady A-Tip
    '375-390-atip': {
      label: '.375 CheyTac – 390gr Hornady A-Tip',
      caliber: '.375 CheyTac',
      brass: 'Peterson (2.994" OAL)',
      projectile: '390gr Hornady A-Tip',
      powder: 'Vihtavuori N570',
      charge: '130',
      primer: 'WRE LRM',
      measurementMode: 'OGIVE',
      dimTarget: '3.120" (ogive)',
      twist: '1:11 or faster',
      projLength: '2.040',
      bcG1: '0.987',
      bcG7: '0.497',
      approxFps: '2950',
      calibration: {
        type: 'mil',
        points: [
          { yards: 1000, value: 5.73 },
          { yards: 1500, value: 10.88 },
          { yards: 2000, value: 17.88 },
          { yards: 2500, value: 27.75 },
          { yards: 3000, value: 41.54 }
        ]
      },
      velCalibration: {
        points: [
          { yards: 1000, vel: 2047 },
          { yards: 2000, vel: 1317 },
          { yards: 2500, vel: 1045 },
          { yards: 3000, vel: 949 }
        ]
      }
    },

    // .375 Cheytac - 400gr WTC
    '375-400-wtc': {
      label: '.375 CheyTac – 400gr WTC',
      caliber: '.375 CheyTac',
      brass: 'Peterson (2.994" OAL)',
      projectile: '400gr Warner Tool Company',
      powder: 'Vihtavuori N570',
      charge: '131',
      primer: 'WRE LRM',
      measurementMode: 'OGIVE',
      dimTarget: '3.366" (ogive)',
      twist: '1:9',
      projLength: '2.350',
      bcG1: '1.103',
      bcG7: '0.552',
      approxFps: '2950',
      calibration: {
        type: 'mil',
        points: [
          { yards: 1000, value: 5.57 },
          { yards: 1500, value: 10.45 },
          { yards: 2000, value: 16.86 },
          { yards: 2500, value: 25.41 },
          { yards: 3000, value: 36.76 }
        ]
      },
      velCalibration: {
        points: [
          { yards: 1000, vel: 2112 },
          { yards: 1500, vel: 1750 },
          { yards: 2000, vel: 1438 },
          { yards: 2500, vel: 1193 },
          { yards: 3000, vel: 1035 }
        ]
      }
    },

    // .375 Cheytac - 425gr CE Lazer
    '375-425-ce-lazer': {
      label: '.375 CheyTac – 425gr CE Lazer',
      caliber: '.375 CheyTac',
      brass: 'Peterson (2.994" OAL)',
      projectile: '425gr Cutting Edge Lazer',
      powder: 'Vihtavuori N570',
      charge: '130',
      primer: 'WRE LRM',
      measurementMode: 'OGIVE',
      dimTarget: '3.235" (ogive)',
      twist: '1:8 or faster',
      projLength: '2.393',
      bcG1: '0.921',
      bcG7: '', // you gave G2 = 0.471; using G1 here
      approxFps: '2825',
      calibration: {
        type: 'mil',
        points: [
          { yards: 1000, value: 6.65 },
          { yards: 1500, value: 12.57 },
          { yards: 2000, value: 20.78 },
          { yards: 2500, value: 32.19 },
          { yards: 3000, value: 47.36 }
        ]
      },
      velCalibration: {
        points: [
          { yards: 1000, vel: 1908 },
          { yards: 1500, vel: 1524 },
          { yards: 2000, vel: 1222 },
          { yards: 2500, vel: 1032 },
          { yards: 3000, vel: 924 }
        ]
      }
    },

    // .375 Cheytac - 350gr CE Lazer
    '375-350-ce-lazer': {
      label: '.375 CheyTac – 350gr CE Lazer',
      caliber: '.375 CheyTac',
      brass: 'Peterson (2.994" OAL)',
      projectile: '350gr Cutting Edge Lazer',
      powder: 'Vihtavuori N570',
      charge: '130',
      primer: 'WRE LRM',
      measurementMode: 'OGIVE',
      dimTarget: '3.215" (ogive)',
      twist: '1:10 or faster',
      projLength: '2.078',
      bcG1: '0.807',
      bcG7: '0.414',
      approxFps: '3050',
      calibration: {
        type: 'mil',
        points: [
          { yards: 1000, value: 5.73 },
          { yards: 1500, value: 11.38 },
          { yards: 2000, value: 19.61 },
          { yards: 2500, value: 31.54 },
          { yards: 3000, value: 47.73 }
        ]
      },
      velCalibration: {
        points: [
          { yards: 1000, vel: 1944 },
          { yards: 1500, vel: 1504 },
          { yards: 2000, vel: 1174 },
          { yards: 2500, vel: 989 },
          { yards: 3000, vel: 885 }
        ]
      }
    },

    // .375 Cheytac - 350gr SMK
    '375-350-smk': {
      label: '.375 CheyTac – 350gr SMK',
      caliber: '.375 CheyTac',
      brass: 'Peterson (2.994" OAL)',
      projectile: '350gr Sierra MatchKing',
      powder: 'Vihtavuori N570',
      charge: '130',
      primer: 'WRE LRM',
      measurementMode: 'OGIVE',
      dimTarget: '3.297" (ogive)',
      twist: '1:10 or faster',
      projLength: '1.768',
      bcG1: '0.805',
      bcG7: '0.400',
      approxFps: '3050',
      calibration: {
        type: 'mil',
        points: [
          { yards: 1000, value: 5.73 },
          { yards: 1500, value: 11.38 },
          { yards: 2000, value: 19.61 },
          { yards: 2500, value: 31.54 },
          { yards: 3000, value: 47.73 }
        ]
      },
      velCalibration: {
        points: [
          { yards: 1000, vel: 1944 },
          { yards: 1500, vel: 1504 },
          { yards: 2000, vel: 1174 },
          { yards: 2500, vel: 989 },
          { yards: 3000, vel: 885 }
        ]
      }
    },

    // .408 Cheytac - 419gr CT Balanced Flight
    '408-419-ct-bf': {
      label: '.408 CheyTac – 419gr CT Balanced Flight',
      caliber: '.408 CheyTac',
      brass: 'Peterson',
      projectile: '419gr CheyTac Balanced Flight',
      powder: 'Vihtavuori N570',
      charge: '131',
      primer: 'WRE LRM',
      measurementMode: 'OGIVE',
      dimTarget: '3.255" (ogive)',
      twist: '1:11 or faster',
      projLength: '2.157',
      bcG1: '0.949',
      bcG7: '', // not provided
      approxFps: '2850',
      calibration: {
        type: 'mil',
        points: [
          { yards: 1000, value: 6.33 },
          { yards: 1500, value: 12.10 },
          { yards: 2000, value: 20.03 },
          { yards: 2500, value: 31.17 },
          { yards: 3000, value: 45.51 }
        ]
      },
      velCalibration: {
        points: [
          { yards: 1000, vel: 1933 },
          { yards: 1500, vel: 1555 },
          { yards: 2000, vel: 1252 },
          { yards: 2500, vel: 1053 },
          { yards: 3000, vel: 941 }
        ]
      }
    },

    // .408 Cheytac 475GR CE Lazer (prototype)
    '408-475-ce-lazer': {
      label: '.408 CheyTac – 475gr CE Lazer (prototype)',
      caliber: '.408 CheyTac',
      brass: 'Peterson',
      projectile: '475gr Cutting Edge Lazer',
      powder: 'Vihtavuori N570',
      charge: '131.5 (HOT – ask Brandyn)',
      primer: 'WRE LRM',
      measurementMode: 'COAL', // no OGIVE given
      dimTarget: '',
      twist: '1:11 or faster',
      projLength: '2.345',
      bcG1: '0.921',
      bcG7: '', // you gave G2 = 0.462
      approxFps: '',
      calibration: {
        type: 'mil',
        points: [
          { yards: 1000, value: 7.28 },
          { yards: 1500, value: 13.98 },
          { yards: 2000, value: 23.33 },
          { yards: 2500, value: 36.16 },
          { yards: 3000, value: 52.87 }
        ]
      },
      velCalibration: {
        points: [
          { yards: 1000, vel: 1790 },
          { yards: 1500, vel: 1426 },
          { yards: 2000, vel: 1154 },
          { yards: 2500, vel: 995 },
          { yards: 3000, vel: 901 }
        ]
      }
    }
  };

  // ===== Simple ballistic model & constants =====
  var BALLISTIC_K = 0.0001; // very approximate decay constant
  var G_FTPS2     = 32.174;
  var SPEED_SOUND = 1125;   // fps
  var MACH_TRAN   = 1340;   // fps (≈ Mach 1.2)

  /**
   * Compute trajectory, then:
   *  - Calibrate drop (MIL) to internal DOPE
   *  - Calibrate velocities to your true velocities at key ranges
   */
  function computeBallistics(v0, bc, maxYards, calibration, velCalibration) {
    var rows = [];

    // Base trajectory (rough) – will be corrected by calibration
    for (var y = 0; y <= maxYards; y++) {
      var xFt = y * 3.0;
      var v   = v0 * Math.exp(-BALLISTIC_K * xFt / bc);

      var t      = (bc / (BALLISTIC_K * v0)) * (Math.exp(BALLISTIC_K * xFt / bc) - 1.0);
      var dropFt = 0.5 * G_FTPS2 * t * t;
      var dropIn = dropFt * 12;

      rows.push({
        yards:  y,
        vel:    v,
        dropIn: dropIn
      });
    }

    // Zero at 100 yd for drop
    var refDrop = 0;
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].yards === 100) {
        refDrop = rows[i].dropIn;
        break;
      }
    }

    rows.forEach(function (r) {
      var diffIn = r.dropIn - refDrop;
      r.dropInFromZero = diffIn;

      if (r.yards > 0) {
        var factor = r.yards / 100;
        r.moa = diffIn / (1.047 * factor);
        r.mil = diffIn / (3.6 * factor);
      } else {
        r.moa = 0;
        r.mil = 0;
      }
    });

    // --- Apply DOPE calibration (MIL) to drop ---
    if (
      calibration &&
      calibration.type === 'mil' &&
      Array.isArray(calibration.points) &&
      calibration.points.length
    ) {
      var byYard = {};
      rows.forEach(function (r) {
        byYard[r.yards] = r;
      });

      var calFactors = [];
      calibration.points.forEach(function (pt) {
        var r = byYard[pt.yards];
        if (!r) return;

        var factorRange = pt.yards / 100;
        if (factorRange <= 0) return;

        // Required drop (inches) from DOPE:
        // drop_in = MIL * 3.6 * (range/100)
        var targetDrop = pt.value * 3.6 * factorRange;
        var modelDrop  = r.dropInFromZero;

        if (!isFinite(modelDrop) || Math.abs(modelDrop) < 1e-6) return;

        var f = targetDrop / modelDrop;
        calFactors.push({ yards: pt.yards, factor: f });
      });

      if (calFactors.length) {
        calFactors.sort(function (a, b) { return a.yards - b.yards; });

        rows.forEach(function (r) {
          var y = r.yards;
          var f;

          if (y <= calFactors[0].yards) {
            f = calFactors[0].factor;
          } else if (y >= calFactors[calFactors.length - 1].yards) {
            f = calFactors[calFactors.length - 1].factor;
          } else {
            for (var i = 0; i < calFactors.length - 1; i++) {
              var c1 = calFactors[i];
              var c2 = calFactors[i + 1];
              if (y >= c1.yards && y <= c2.yards) {
                var t = (y - c1.yards) / (c2.yards - c1.yards);
                f = c1.factor + t * (c2.factor - c1.factor);
                break;
              }
            }
          }

          if (!isFinite(f) || f <= 0) {
            return; // leave row as-is
          }

          var adjDrop = r.dropInFromZero * f;
          r.dropInFromZero = adjDrop;

          if (y > 0) {
            var rangeFactor = y / 100;
            r.moa = adjDrop / (1.047 * rangeFactor);
            r.mil = adjDrop / (3.6 * rangeFactor);
          } else {
            r.moa = 0;
            r.mil = 0;
          }
        });
      }
    }

    // --- Apply velocity calibration (force your FPS at key ranges) ---
    if (
      velCalibration &&
      Array.isArray(velCalibration.points) &&
      velCalibration.points.length
    ) {
      var velPoints = velCalibration.points
        .map(function (p) {
          return { yards: p.yards, vel: p.vel };
        })
        .filter(function (p) {
          return isFinite(p.yards) && isFinite(p.vel);
        });

      // Add muzzle velocity at 0 yd as an anchor
      if (isFinite(v0) && v0 > 0) {
        velPoints.push({ yards: 0, vel: v0 });
      }

      if (velPoints.length) {
        velPoints.sort(function (a, b) { return a.yards - b.yards; });

        rows.forEach(function (r) {
          var y = r.yards;

          var vCal;

          if (y <= velPoints[0].yards) {
            // before first calibration point – interpolate from (0, v0) to first point
            var p0 = velPoints[0];
            if (p0.yards === 0) {
              vCal = p0.vel;
            } else {
              var t0 = y / p0.yards;
              vCal = v0 + t0 * (p0.vel - v0);
            }
          } else if (y >= velPoints[velPoints.length - 1].yards) {
            // after last calibration point – linear extrapolation from last two
            if (velPoints.length === 1) {
              vCal = velPoints[0].vel;
            } else {
              var pA = velPoints[velPoints.length - 2];
              var pB = velPoints[velPoints.length - 1];
              var spanY = pB.yards - pA.yards || 1;
              var t1 = (y - pA.yards) / spanY;
              vCal = pA.vel + t1 * (pB.vel - pA.vel);
            }
          } else {
            // between two calibration points – linear interpolation
            for (var i = 0; i < velPoints.length - 1; i++) {
              var c1 = velPoints[i];
              var c2 = velPoints[i + 1];
              if (y >= c1.yards && y <= c2.yards) {
                var span = c2.yards - c1.yards || 1;
                var t = (y - c1.yards) / span;
                vCal = c1.vel + t * (c2.vel - c1.vel);
                break;
              }
            }
          }

          if (isFinite(vCal) && vCal > 0) {
            r.vel = vCal;
          }
        });
      }
    }

    // Recompute transonic / subsonic based on final velocities
    var transYards = null;
    var subYards   = null;
    for (var i2 = 0; i2 < rows.length; i2++) {
      var vNow = rows[i2].vel;
      var yNow = rows[i2].yards;

      if (transYards === null && vNow <= MACH_TRAN && vNow > SPEED_SOUND) {
        transYards = yNow;
      }
      if (subYards === null && vNow <= SPEED_SOUND) {
        subYards = yNow;
      }
    }

    return {
      rows: rows,
      transYards: transYards,
      subYards: subYards
    };
  }

  function initFormLogic() {
    if (initialized) return;
    initialized = true;

    var form         = document.getElementById('ammo-batch-qc-form');
    var printBtn     = document.getElementById('bb-print-batch');
    var batchDisplay = document.getElementById('bb-batch-id-display');
    var batchHidden  = document.getElementById('bb-batch-id-hidden');
    var dateField    = document.getElementById('bb-batch-date');
    var loadSelect   = document.getElementById('bb-load');
    var samplesEl    = document.getElementById('bb-samples');

    if (!form || !printBtn) return;

    // Auto batch ID = YYYYMMDD-HHMMSS, plus formatted date/time
    (function initBatchIdAndDate() {
      var d   = new Date();
      var y   = d.getFullYear();
      var mo  = pad2(d.getMonth() + 1);
      var da  = pad2(d.getDate());
      var h   = pad2(d.getHours());
      var mi  = pad2(d.getMinutes());
      var s   = pad2(d.getSeconds());

      var dateStr     = y + '-' + mo + '-' + da;
      var timeStr     = h + ':' + mi;
      var dateTimeStr = dateStr + ' ' + timeStr;
      var batchId     = dateStr.replace(/-/g, '') + '-' + h + mi + s;

      if (batchDisplay) batchDisplay.value = batchId;
      if (batchHidden)  batchHidden.value  = batchId;
      if (dateField)    dateField.value    = dateTimeStr;
    })();

    function getVal(id) {
      var el = document.getElementById(id);
      return el ? (el.value || '').trim() : '';
    }

    // Show/hide sample rows based on select
    function updateSampleVisibility() {
      var blocks = document.querySelectorAll('.bb-sample-block');
      if (!samplesEl || !blocks.length) return;

      var count = parseInt(samplesEl.value, 10);
      if (!isFinite(count) || count < 1) count = 1;
      if (count > 12) count = 12;

      blocks.forEach(function (block) {
        var idx = parseInt(block.getAttribute('data-sample-index'), 10);
        if (!isFinite(idx)) idx = 0;
        if (idx > 0 && idx <= count) {
          block.style.display = 'block';
        } else {
          block.style.display = 'none';
        }
      });
    }

    updateSampleVisibility();
    if (samplesEl) {
      samplesEl.addEventListener('change', updateSampleVisibility);
    }

    // Apply recipe when load is chosen
    function applyRecipe(key) {
      var r = RECIPES[key];
      if (!r) return;

      var caliberEl  = document.getElementById('bb-caliber');
      var brassEl    = document.getElementById('bb-brass');
      var projEl     = document.getElementById('bb-projectile');
      var powderEl   = document.getElementById('bb-powder');
      var chargeEl   = document.getElementById('bb-charge');
      var primerEl   = document.getElementById('bb-primer');
      var dimInput   = document.getElementById('bb-coal');
      var dimLabelEl = document.getElementById('bb-coal-label');

      var twistEl   = document.getElementById('bb-twist');
      var projLenEl = document.getElementById('bb-proj-len');
      var bcG1El    = document.getElementById('bb-bc-g1');
      var bcG7El    = document.getElementById('bb-bc-g7');

      if (caliberEl && r.caliber)   caliberEl.value   = r.caliber;
      if (brassEl && r.brass)       brassEl.value     = r.brass;
      if (projEl && r.projectile)   projEl.value      = r.projectile;
      if (powderEl && r.powder)     powderEl.value    = r.powder;
      if (chargeEl && r.charge)     chargeEl.value    = r.charge;
      if (primerEl && r.primer)     primerEl.value    = r.primer;
      if (dimInput && r.dimTarget)  dimInput.value    = r.dimTarget;

      if (twistEl && r.twist)           twistEl.value    = r.twist;
      if (projLenEl && r.projLength)    projLenEl.value  = r.projLength;
      if (bcG1El && r.bcG1)             bcG1El.value     = r.bcG1;
      if (bcG7El && r.bcG7)             bcG7El.value     = r.bcG7;

      currentMeasureMode = r.measurementMode === 'OGIVE' ? 'OGIVE' : 'COAL';

      var dimLabelText = currentMeasureMode === 'OGIVE'
        ? 'OGIVE target / range'
        : 'COAL target / range';

      if (dimLabelEl) dimLabelEl.textContent = dimLabelText;
    }

    if (loadSelect) {
      loadSelect.addEventListener('change', function () {
        var key = loadSelect.value;
        if (RECIPES[key]) {
          applyRecipe(key);
        }
      });
    }

    // === PRINT BUTTON: build sheet & ballistics in new tab ===
    printBtn.addEventListener('click', function () {
      if (form.reportValidity && !form.reportValidity()) {
        return;
      }

      var batchId     = getVal('bb-batch-id-display');
      var batchDate   = getVal('bb-batch-date');
      var orderNumber = getVal('bb-order');

      var loadRecipe  = (function () {
        var sel = loadSelect;
        if (!sel) return '';
        var opt = sel.options[sel.selectedIndex];
        return opt ? opt.textContent.trim() : '';
      })();

      var caliber     = getVal('bb-caliber');
      var qty         = getVal('bb-qty');
      var brass       = getVal('bb-brass');
      var projectile  = getVal('bb-projectile');
      var powder      = getVal('bb-powder');
      var charge      = getVal('bb-charge');
      var primer      = getVal('bb-primer');

      var twist       = getVal('bb-twist');
      var projLen     = getVal('bb-proj-len');
      var bcG1        = getVal('bb-bc-g1');
      var bcG7        = getVal('bb-bc-g7');

      var brassLot    = getVal('bb-brass-lot');
      var powderLot   = getVal('bb-powder-lot');
      var primerLot   = getVal('bb-primer-lot');

      var dimTarget   = getVal('bb-coal');
      var samplesStr  = getVal('bb-samples');
      var velAvg      = getVal('bb-vel-avg');
      var velEs       = getVal('bb-vel-es');
      var velSd       = getVal('bb-vel-sd');
      var groupSize   = getVal('bb-group');
      var operator    = getVal('bb-operator');
      var qcCheckedBy = getVal('bb-qc');
      var status      = getVal('bb-status');

      var notesEl  = document.getElementById('bb-notes');
      var notesRaw = notesEl ? notesEl.value : '';
      notesRaw     = notesRaw.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

      var sampleCount = parseInt(samplesStr, 10);
      if (!isFinite(sampleCount) || sampleCount < 1) sampleCount = 1;
      if (sampleCount > 12) sampleCount = 12;

      var samplesData = [];
      for (var i = 1; i <= sampleCount; i++) {
        samplesData.push({
          idx:    i,
          dim:    getVal('bb-s' + i + '-dim'),
          primer: getVal('bb-s' + i + '-primer'),
          oal:    getVal('bb-s' + i + '-oal'),
          weight: getVal('bb-s' + i + '-weight'),
          proj:   getVal('bb-s' + i + '-proj'),
          vel:    getVal('bb-s' + i + '-vel')
        });
      }

      // Ballistic inputs: use chrono avg & BC
      var bcNumeric = NaN;
      if (bcG7) {
        bcNumeric = parseFloat(bcG7);
      } else if (bcG1) {
        bcNumeric = parseFloat(bcG1);
      }
      var muzzleVel = parseFloat(velAvg || '');
      var hasBallisticInputs =
        !isNaN(bcNumeric) && bcNumeric > 0 &&
        !isNaN(muzzleVel) && muzzleVel > 0;

      var w = window.open('', '_blank');
      if (!w) {
        alert('Popup blocked. Allow popups for this site to open the batch sheet.');
        return;
      }

      var doc  = w.document;
      var head = doc.head || doc.getElementsByTagName('head')[0];
      var body = doc.body || doc.getElementsByTagName('body')[0];

      if (!head) {
        head = doc.createElement('head');
        doc.documentElement.insertBefore(head, doc.documentElement.firstChild);
      }
      if (!body) {
        body = doc.createElement('body');
        doc.documentElement.appendChild(body);
      }

      doc.title = 'Ammo Batch & QC Log';

      var style = doc.createElement('style');
      style.textContent = `
        * { box-sizing: border-box; }
        body {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          margin: 0;
          padding: 2rem;
          background: #0f172a;
          color: #0b1120;
        }
        .bb-batch-sheet {
          max-width: 900px;
          margin: 0 auto;
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 0 20px 45px rgba(15, 23, 42, 0.25);
          padding: 2.25rem 2.5rem 2.3rem;
        }
        .bb-batch-header {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          margin-bottom: 1.75rem;
          border-bottom: 1px solid #e5e7eb;
          padding-bottom: 1.5rem;
        }
        .bb-batch-logo {
          max-height: 64px;
          margin-bottom: 0.75rem;
        }
        .bb-batch-business-name {
          font-size: 1.25rem;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          margin-bottom: 0.3rem;
        }
        .bb-batch-contact {
          font-size: 0.85rem;
          color: #6b7280;
          line-height: 1.5;
        }
        .bb-batch-contact a {
          color: inherit;
          text-decoration: none;
        }
        .bb-batch-meta {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 1.25rem;
          margin-top: 1rem;
          font-size: 0.9rem;
          color: #4b5563;
        }
        .bb-batch-meta-item {
          display: flex;
          gap: 0.35rem;
          align-items: baseline;
        }
        .bb-batch-meta-label {
          font-weight: 600;
        }
        .bb-batch-meta-value {
          font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
            "Liberation Mono", "Courier New", monospace;
        }

        .bb-batch-sections {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1.25rem;
          margin-top: 1.5rem;
        }
        @media (max-width: 768px) {
          .bb-batch-sections {
            grid-template-columns: 1fr;
          }
        }
        .bb-batch-section {
          border-radius: 10px;
          border: 1px solid #e5e7eb;
          background: #f9fafb;
          padding: 1rem 1.1rem;
        }
        .bb-batch-section-title {
          font-size: 0.8rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.12em;
          color: #6b7280;
          margin-bottom: 0.5rem;
        }
        .bb-batch-row {
          display: flex;
          font-size: 0.9rem;
          margin-bottom: 0.25rem;
        }
        .bb-batch-label {
          width: 48%;
          max-width: 220px;
          font-weight: 500;
          color: #4b5563;
        }
        .bb-batch-value {
          flex: 1;
          color: #111827;
        }

        .bb-batch-notes {
          margin-top: 1.5rem;
          border-radius: 10px;
          border: 1px solid #e5e7eb;
          background: #f9fafb;
          padding: 1rem 1.1rem;
        }
        .bb-batch-notes-title {
          font-size: 0.8rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.12em;
          color: #6b7280;
          margin-bottom: 0.5rem;
        }
        .bb-batch-notes-body {
          font-size: 0.9rem;
          white-space: pre-wrap;
          color: #111827;
        }

        .bb-batch-samples {
          margin-top: 1rem;
          font-size: 0.85rem;
        }
        .bb-batch-samples-title {
          font-size: 0.8rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.12em;
          color: #6b7280;
          margin-bottom: 0.25rem;
        }
        .bb-batch-samples-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 0.8rem;
        }
        .bb-batch-samples-table th,
        .bb-batch-samples-table td {
          padding: 0.25rem 0.35rem;
          border-bottom: 1px solid #e5e7eb;
          text-align: left;
        }
        .bb-batch-samples-table th {
          font-weight: 600;
          color: #6b7280;
          text-transform: uppercase;
          letter-spacing: 0.06em;
        }
        .bb-batch-samples-table th:first-child,
        .bb-batch-samples-table td:first-child {
          width: 1.6rem;
          text-align: center;
        }

        .bb-bc-header {
          border-bottom: 1px solid #e5e7eb;
          padding-bottom: 0.9rem;
          margin-bottom: 0.9rem;
        }
        .bb-bc-title {
          font-size: 1.1rem;
          font-weight: 600;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          margin-bottom: 0.25rem;
        }
        .bb-bc-meta {
          font-size: 0.85rem;
          color: #6b7280;
          line-height: 1.4;
        }
        .bb-bc-meta strong {
          color: #374151;
        }
        .bb-bc-table-wrap {
          margin-top: 0.6rem;
        }
        .bb-bc-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 0.8rem;
        }
        .bb-bc-table th,
        .bb-bc-table td {
          padding: 0.25rem 0.35rem;
          border-bottom: 1px solid #e5e7eb;
          text-align: right;
          white-space: nowrap;
        }
        .bb-bc-table th:first-child,
        .bb-bc-table td:first-child {
          text-align: left;
        }
        .bb-bc-table th {
          font-weight: 600;
          color: #6b7280;
          text-transform: uppercase;
          letter-spacing: 0.06em;
        }

        .bb-bc-row-trans {
          background: rgba(234, 179, 8, 0.18);
        }
        .bb-bc-row-sub {
          background: rgba(248, 113, 113, 0.2);
        }

        .bb-bc-footnote {
          margin-top: 0.6rem;
          font-size: 0.75rem;
          color: #9ca3af;
        }

        @media print {
          body {
            background: #ffffff;
            padding: 0;
          }
          .bb-batch-sheet {
            box-shadow: none;
            border-radius: 0;
            margin: 0;
            max-width: 100%;
          }
          .bb-batch-section {
            break-inside: avoid-page;
            page-break-inside: avoid;
          }
          .bb-bc-page {
            page-break-before: always;
          }
          .bb-bc-row-trans {
            background-color: rgba(234, 179, 8, 0.35) !important;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          .bb-bc-row-sub {
            background-color: rgba(248, 113, 113, 0.4) !important;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        }
      `;
      head.appendChild(style);

      function addRow(sectionEl, label, value) {
        var row = doc.createElement('div');
        row.className = 'bb-batch-row';

        var labelEl = doc.createElement('div');
        labelEl.className = 'bb-batch-label';
        labelEl.textContent = label;

        var valueEl = doc.createElement('div');
        valueEl.className = 'bb-batch-value';
        valueEl.textContent = value && value.length ? value : '—';

        row.appendChild(labelEl);
        row.appendChild(valueEl);
        sectionEl.appendChild(row);
      }

      // === First page: batch summary & QC ===
      var sheet = doc.createElement('div');
      sheet.className = 'bb-batch-sheet';
      body.appendChild(sheet);

      var header = doc.createElement('div');
      header.className = 'bb-batch-header';
      sheet.appendChild(header);

      var logoUrl = 'https://cdn.shopify.com/s/files/1/0869/0896/1058/files/Untitled_design_25.png?v=1761693898';

      if (logoUrl) {
        var logoImg = doc.createElement('img');
        logoImg.className = 'bb-batch-logo';
        logoImg.src = logoUrl;
        logoImg.alt = 'B&B Firearms logo';
        header.appendChild(logoImg);
      }

      var businessName = 'B&B Firearms';
      var phone        = '484-616-0403';
      var email        = 'brandyn@bnbfirearms.com';
      var address      = '476 N Heidelberg Rd, Robesonia, PA 19551';
      var website      = 'bnbfirearms.com';

      var nameEl = doc.createElement('div');
      nameEl.className = 'bb-batch-business-name';
      nameEl.textContent = businessName;
      header.appendChild(nameEl);

      var contactEl = doc.createElement('div');
      contactEl.className = 'bb-batch-contact';
      contactEl.innerHTML =
        address + '<br>' +
        'Phone: ' + phone + ' &nbsp;•&nbsp; ' +
        '<a href="mailto:' + email + '">' + email + '</a><br>' +
        '<a href="https://' + website + '">' + website + '</a>';
      header.appendChild(contactEl);

      var meta = doc.createElement('div');
      meta.className = 'bb-batch-meta';
      header.appendChild(meta);

      if (batchId) {
        var m1 = doc.createElement('div');
        m1.className = 'bb-batch-meta-item';
        m1.innerHTML =
          '<span class="bb-batch-meta-label">Batch ID:</span>' +
          '<span class="bb-batch-meta-value">' + batchId + '</span>';
        meta.appendChild(m1);
      }
      if (batchDate) {
        var m2 = doc.createElement('div');
        m2.className = 'bb-batch-meta-item';
        m2.innerHTML =
          '<span class="bb-batch-meta-label">Batch date &amp; time:</span>' +
          '<span class="bb-batch-meta-value">' + batchDate + '</span>';
        meta.appendChild(m2);
      }
      if (orderNumber) {
        var m3 = doc.createElement('div');
        m3.className = 'bb-batch-meta-item';
        m3.innerHTML =
          '<span class="bb-batch-meta-label">Order #:</span>' +
          '<span class="bb-batch-meta-value">' + orderNumber + '</span>';
        meta.appendChild(m3);
      }
      if (loadRecipe) {
        var m4 = doc.createElement('div');
        m4.className = 'bb-batch-meta-item';
        m4.innerHTML =
          '<span class="bb-batch-meta-label">Load recipe:</span>' +
          '<span class="bb-batch-meta-value">' + loadRecipe + '</span>';
        meta.appendChild(m4);
      }

      var sectionsGrid = doc.createElement('div');
      sectionsGrid.className = 'bb-batch-sections';
      sheet.appendChild(sectionsGrid);

      // Batch basics
      var basicsSection = doc.createElement('div');
      basicsSection.className = 'bb-batch-section';
      sectionsGrid.appendChild(basicsSection);

      var basicsTitle = doc.createElement('div');
      basicsTitle.className = 'bb-batch-section-title';
      basicsTitle.textContent = 'Batch Basics';
      basicsSection.appendChild(basicsTitle);

      addRow(basicsSection, 'Caliber / Cartridge', caliber);
      addRow(basicsSection, 'Total rounds in batch', qty);

      // Components & ballistic data
      var componentsSection = doc.createElement('div');
      componentsSection.className = 'bb-batch-section';
      sectionsGrid.appendChild(componentsSection);

      var compTitle = doc.createElement('div');
      compTitle.className = 'bb-batch-section-title';
      compTitle.textContent = 'Component Details & Projectile Data';
      componentsSection.appendChild(compTitle);

      addRow(componentsSection, 'Brass (type)', brass);
      addRow(componentsSection, 'Projectile (weight / type)', projectile);
      addRow(componentsSection, 'Powder (brand / type)', powder);
      addRow(componentsSection, 'Charge weight (grains)', charge);
      addRow(componentsSection, 'Primer (brand / type)', primer);
      addRow(componentsSection, 'Suggested twist rate', twist);
      addRow(componentsSection, 'Projectile length (inches)', projLen);
      addRow(componentsSection, 'Ballistic Coefficient G1', bcG1);
      addRow(componentsSection, 'Ballistic Coefficient G7', bcG7);

      // QC
      var qcSection = doc.createElement('div');
      qcSection.className = 'bb-batch-section';
      sectionsGrid.appendChild(qcSection);

      var qcTitle = doc.createElement('div');
      qcTitle.className = 'bb-batch-section-title';
      qcTitle.textContent = 'QC Measurements';
      qcSection.appendChild(qcTitle);

      var dimLabelText = currentMeasureMode === 'OGIVE'
        ? 'OGIVE target / range'
        : 'COAL target / range';

      addRow(qcSection, 'Brass batch / lot (REQUIRED)', brassLot);
      addRow(qcSection, 'Powder batch / lot (REQUIRED)', powderLot);
      addRow(qcSection, 'Primer batch / lot (REQUIRED)', primerLot);
      addRow(qcSection, dimLabelText, dimTarget);
      addRow(qcSection, 'Number of rounds sampled', samplesStr || String(sampleCount));
      addRow(qcSection, 'Velocity Avg (fps)', velAvg);
      addRow(qcSection, 'Velocity ES', velEs);
      addRow(qcSection, 'Velocity SD', velSd);
      addRow(qcSection, 'Group size @ distance', groupSize);

      // Sample grid on sheet
      var samplesBlock = doc.createElement('div');
      samplesBlock.className = 'bb-batch-samples';
      qcSection.appendChild(samplesBlock);

      var samplesTitleEl = doc.createElement('div');
      samplesTitleEl.className = 'bb-batch-samples-title';
      samplesTitleEl.textContent = 'Sample measurements (' + sampleCount + ' rounds)';
      samplesBlock.appendChild(samplesTitleEl);

      var samplesTable = doc.createElement('table');
      samplesTable.className = 'bb-batch-samples-table';
      samplesBlock.appendChild(samplesTable);

      var thead = doc.createElement('thead');
      var headRow = doc.createElement('tr');
      var dimHeading = currentMeasureMode === 'OGIVE' ? 'OGIVE' : 'COAL';

      ['#', dimHeading, 'Primer depth', 'Brass OAL', 'Case weight', 'Projectile weight', 'Velocity (fps)'].forEach(function (text) {
        var th = doc.createElement('th');
        th.textContent = text;
        headRow.appendChild(th);
      });
      thead.appendChild(headRow);
      samplesTable.appendChild(thead);

      var tbody = doc.createElement('tbody');
      samplesData.forEach(function (s) {
        var tr = doc.createElement('tr');

        function cell(value) {
          var td = doc.createElement('td');
          td.textContent = value && value.length ? value : '—';
          return td;
        }

        tr.appendChild(cell(String(s.idx)));
        tr.appendChild(cell(s.dim));
        tr.appendChild(cell(s.primer));
        tr.appendChild(cell(s.oal));
        tr.appendChild(cell(s.weight));
        tr.appendChild(cell(s.proj));
        tr.appendChild(cell(s.vel));

        tbody.appendChild(tr);
      });
      samplesTable.appendChild(tbody);

      // Sign-off
      var signSection = doc.createElement('div');
      signSection.className = 'bb-batch-section';
      sectionsGrid.appendChild(signSection);

      var signTitle = doc.createElement('div');
      signTitle.className = 'bb-batch-section-title';
      signTitle.textContent = 'Sign-Off';
      signSection.appendChild(signTitle);

      addRow(
        signSection,
        'Loaded by (operator)',
        operator ? operator + '  ____________________' : '____________________'
      );
      addRow(
        signSection,
        'QC checked by',
        qcCheckedBy ? qcCheckedBy + '  ____________________' : '____________________'
      );
      addRow(signSection, 'QC status', status);

      // Notes
      var notesSection = doc.createElement('div');
      notesSection.className = 'bb-batch-notes';
      sheet.appendChild(notesSection);

      var notesTitle = doc.createElement('div');
      notesTitle.className = 'bb-batch-notes-title';
      notesTitle.textContent = 'Notes / issues / observations';
      notesSection.appendChild(notesTitle);

      var notesBody = doc.createElement('div');
      notesBody.className = 'bb-batch-notes-body';
      notesBody.textContent = notesRaw && notesRaw.length ? notesRaw : '—';
      notesSection.appendChild(notesBody);

      var footer = doc.createElement('div');
      footer.style.marginTop = '1.5rem';
      footer.style.fontSize = '0.75rem';
      footer.style.textAlign = 'right';
      footer.style.color = '#9ca3af';
      footer.textContent = 'Internal use only – retain this record for 5 years.';
      sheet.appendChild(footer);

      // === Ballistic MOA + MIL pages (only if BC & velocity provided) ===
      if (hasBallisticInputs) {
        var maxRangeYds = 3000;

        // Get calibration for selected recipe
        var loadKey = loadSelect ? loadSelect.value : '';
        var recipeForBallistics = RECIPES[loadKey];
        var calibration   = recipeForBallistics && recipeForBallistics.calibration
          ? recipeForBallistics.calibration
          : null;
        var velCalibration = recipeForBallistics && recipeForBallistics.velCalibration
          ? recipeForBallistics.velCalibration
          : null;

        var ball = computeBallistics(muzzleVel, bcNumeric, maxRangeYds, calibration, velCalibration);
        var rowsFine = ball.rows;
        var transY = ball.transYards;
        var subY   = ball.subYards;

        function formatNum(n, digits) {
          return isFinite(n) ? n.toFixed(digits) : '—';
        }

        function buildDisplayRows() {
          var byYard = {};
          for (var i = 0; i < rowsFine.length; i++) {
            byYard[rowsFine[i].yards] = rowsFine[i];
          }

          var display = [];
          for (var y = 0; y <= maxRangeYds; y += 100) {
            if (byYard[y]) display.push(byYard[y]);
          }

          function addSpecial(ySpecial) {
            if (ySpecial == null) return;
            var r = byYard[ySpecial];
            if (!r) return;
            var exists = display.some(function (row) { return row.yards === ySpecial; });
            if (!exists) display.push(r);
          }

          addSpecial(transY);
          addSpecial(subY);

          display.sort(function (a, b) {
            return a.yards - b.yards;
          });

          return display;
        }

        var displayRows = buildDisplayRows();
        var bcLabelUsed = bcG7 ? ('G7 ' + bcG7) : (bcG1 ? ('G1 ' + bcG1) : '—');

        var metaTextLine =
          (loadRecipe || 'Custom load') +
          (caliber ? ' • ' + caliber : '') +
          (muzzleVel ? ' • MV: ' + muzzleVel + ' fps' : '') +
          (bcLabelUsed ? ' • BC: ' + bcLabelUsed : '');

        var transText = transY ? (transY + ' yd (approx)') : 'N/A';
        var subText   = subY   ? (subY   + ' yd (approx)') : 'N/A';

        // --- MOA page ---
        var moaPage = doc.createElement('div');
        moaPage.className = 'bb-batch-sheet bb-bc-page';
        body.appendChild(moaPage);

        var moaHeader = doc.createElement('div');
        moaHeader.className = 'bb-bc-header';
        moaPage.appendChild(moaHeader);

        var moaTitle = doc.createElement('div');
        moaTitle.className = 'bb-bc-title';
        moaTitle.textContent = 'Ballistic Data Card – MOA';
        moaHeader.appendChild(moaTitle);

        var moaMeta = doc.createElement('div');
        moaMeta.className = 'bb-bc-meta';
        moaMeta.innerHTML =
          '<strong>Load:</strong> ' + metaTextLine + '<br>' +
          '<strong>Zero:</strong> 100 yd &nbsp;•&nbsp; ' +
          '<strong>Transonic:</strong> ' + transText + ' &nbsp;•&nbsp; ' +
          '<strong>Subsonic:</strong> ' + subText;
        moaHeader.appendChild(moaMeta);

        var moaTableWrap = doc.createElement('div');
        moaTableWrap.className = 'bb-bc-table-wrap';
        moaPage.appendChild(moaTableWrap);

        var moaTable = doc.createElement('table');
        moaTable.className = 'bb-bc-table';
        moaTableWrap.appendChild(moaTable);

        var moaThead = doc.createElement('thead');
        var moaHeadRow = doc.createElement('tr');
        ['Range (yd)', 'Drop (MOA)', 'Drop (in)', 'Velocity (fps)', 'Mach'].forEach(function (text) {
          var th = doc.createElement('th');
          th.textContent = text;
          moaHeadRow.appendChild(th);
        });
        moaThead.appendChild(moaHeadRow);
        moaTable.appendChild(moaThead);

        var moaTbody = doc.createElement('tbody');
        displayRows.forEach(function (r) {
          var tr = doc.createElement('tr');

          if (transY != null && r.yards === transY) {
            tr.classList.add('bb-bc-row-trans');
          }
          if (subY != null && r.yards === subY) {
            tr.classList.add('bb-bc-row-sub');
          }

          var machVal = r.vel / SPEED_SOUND;

          [
            r.yards.toString(),
            formatNum(r.moa, 2),
            formatNum(r.dropInFromZero, 1),
            formatNum(r.vel, 0),
            formatNum(machVal, 2)
          ].forEach(function (v) {
            var td = doc.createElement('td');
            td.textContent = v;
            tr.appendChild(td);
          });

          moaTbody.appendChild(tr);
        });
        moaTable.appendChild(moaTbody);

        var moaFoot = doc.createElement('div');
        moaFoot.className = 'bb-bc-footnote';
        moaFoot.textContent =
          'Approximate ballistic table calibrated to internal DOPE. Verify with actual rifle/environment before use.';
        moaPage.appendChild(moaFoot);

        // --- MIL page ---
        var milPage = doc.createElement('div');
        milPage.className = 'bb-batch-sheet bb-bc-page';
        body.appendChild(milPage);

        var milHeader = doc.createElement('div');
        milHeader.className = 'bb-bc-header';
        milPage.appendChild(milHeader);

        var milTitle = doc.createElement('div');
        milTitle.className = 'bb-bc-title';
        milTitle.textContent = 'Ballistic Data Card – MIL';
        milHeader.appendChild(milTitle);

        var milMeta = doc.createElement('div');
        milMeta.className = 'bb-bc-meta';
        milMeta.innerHTML =
          '<strong>Load:</strong> ' + metaTextLine + '<br>' +
          '<strong>Zero:</strong> 100 yd &nbsp;•&nbsp; ' +
          '<strong>Transonic:</strong> ' + transText + ' &nbsp;•&nbsp; ' +
          '<strong>Subsonic:</strong> ' + subText;
        milHeader.appendChild(milMeta);

        var milTableWrap = doc.createElement('div');
        milTableWrap.className = 'bb-bc-table-wrap';
        milPage.appendChild(milTableWrap);

        var milTable = doc.createElement('table');
        milTable.className = 'bb-bc-table';
        milTableWrap.appendChild(milTable);

        var milThead = doc.createElement('thead');
        var milHeadRow = doc.createElement('tr');
        ['Range (yd)', 'Drop (MIL)', 'Drop (in)', 'Velocity (fps)', 'Mach'].forEach(function (text) {
          var th = doc.createElement('th');
          th.textContent = text;
          milHeadRow.appendChild(th);
        });
        milThead.appendChild(milHeadRow);
        milTable.appendChild(milThead);

        var milTbody = doc.createElement('tbody');
        displayRows.forEach(function (r) {
          var tr = doc.createElement('tr');

          if (transY != null && r.yards === transY) {
            tr.classList.add('bb-bc-row-trans');
          }
          if (subY != null && r.yards === subY) {
            tr.classList.add('bb-bc-row-sub');
          }

          var machVal2 = r.vel / SPEED_SOUND;

          [
            r.yards.toString(),
            formatNum(r.mil, 2),
            formatNum(r.dropInFromZero, 1),
            formatNum(r.vel, 0),
            formatNum(machVal2, 2)
          ].forEach(function (v) {
            var td = doc.createElement('td');
            td.textContent = v;
            tr.appendChild(td);
          });

          milTbody.appendChild(tr);
        });
        milTable.appendChild(milTbody);

        var milFoot = doc.createElement('div');
        milFoot.className = 'bb-bc-footnote';
        milFoot.textContent =
          'Approximate ballistic table calibrated to internal DOPE. Verify with actual rifle/environment before use.';
        milPage.appendChild(milFoot);
      }
    });
  }

  function showForm() {
    if (lock)    lock.style.display = 'none';
    if (wrapper) wrapper.style.display = '';
    initFormLogic();
  }

  function handleUnlockAttempt() {
    if (!passInput) return;
    var val = passInput.value || '';
    if (val === INTERNAL_PASSWORD) {
      if (errorEl) errorEl.style.display = 'none';
      localStorage.setItem('bbBatchUnlocked', '1');
      showForm();
    } else {
      if (errorEl) errorEl.style.display = 'block';
    }
  }

  if (localStorage.getItem('bbBatchUnlocked') === '1') {
    showForm();
  } else {
    if (unlockBtn) {
      unlockBtn.addEventListener('click', handleUnlockAttempt);
    }
    if (passInput) {
      passInput.addEventListener('keyup', function (e) {
        if (e.key === 'Enter') {
          handleUnlockAttempt();
        }
      });
    }
  }
});
